export default __webpack_public_path__ + "static/media/TV5.fc5cdef3.mp4";